import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

export const sendResetInstructions = async ({ email }) => {
  const response = await post(`${RAISE_API_V1_URL}/passwords`, {
    email
  });
  return response.data;
};
